import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { KeyRound } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';

const API = process.env.REACT_APP_BACKEND_URL;
const EMPTY = { current: '', next: '', confirm: '' };

const errText = (err) => {
  const d = err.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return 'New password must be 8–72 characters.';
  return 'Something went wrong. Please try again.';
};

export const ChangePasswordDialog = ({ token, onToken }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (f.next.length < 8) { setError('New password must be at least 8 characters.'); return; }
    if (f.next !== f.confirm) { setError("New passwords don't match."); return; }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/api/auth/change-password`,
        { current_password: f.current, new_password: f.next }, { headers: { Authorization: `Bearer ${token}` } });
      onToken(data.token);
      toast.success('Password changed');
      setF(EMPTY);
      setOpen(false);
    } catch (err) { setError(errText(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setError(''); }}>
      <DialogTrigger asChild>
        <Button variant="outline" data-testid="owner-change-password-open"><KeyRound size={16} /> Change password</Button>
      </DialogTrigger>
      <DialogContent className="site-theme" data-testid="owner-change-password-dialog">
        <DialogHeader><DialogTitle>Change password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="o-pw-form">
          <div><Label htmlFor="pw-cur">Current password</Label>
            <Input id="pw-cur" type="password" value={f.current} onChange={set('current')} required data-testid="owner-current-password" /></div>
          <div><Label htmlFor="pw-new">New password (8+ characters)</Label>
            <Input id="pw-new" type="password" value={f.next} onChange={set('next')} required data-testid="owner-new-password" /></div>
          <div><Label htmlFor="pw-conf">Confirm new password</Label>
            <Input id="pw-conf" type="password" value={f.confirm} onChange={set('confirm')} required data-testid="owner-confirm-password" /></div>
          {error && <p className="o-error" data-testid="owner-change-password-error">{error}</p>}
          <Button type="submit" className="w-btn-primary" disabled={busy} data-testid="owner-change-password-submit">
            {busy ? 'Saving...' : 'Save new password'}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ChangePasswordDialog;
